import { focusBoxShadow, hexToRGB, Text, Theme, useStyles } from 'bold-ui'
import { NormalizedHighlighter } from 'components/highlight/NormalizedHighlighter'
import { BadgeNotificacao } from 'components/notificacao/BadgeNotificacao'
import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import { useConfiguracoes } from 'hooks/configuracoes'
import { useFirebase } from 'hooks/firebase/useFirebase'
import { useNotificacaoCount } from 'hooks/notificacao/useNotificacaoCount'
import { CSSProperties } from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import {
  RELATORIO_GERENCIAL_ATENDIMENTOS_PATH,
  RELATORIO_GERENCIAL_VACINACAO_PATH,
} from 'view/relatorio/relatoriosgerenciais/common/model-relatorioGerencial'

export interface SideMenuSubLinkProps extends NavLinkProps {
  title: string
  highlight?: string
  logEventParameter?: string
  notificacoes?: TipoTopicoNotificacaoEnum[]
  onNavigate?(): void
}

export function SideMenuSubLink(props: SideMenuSubLinkProps) {
  const { classes } = useStyles(createStyles, true)
  const { title, highlight, onNavigate, logEventParameter, to, notificacoes, ...rest } = props
  const { analytics } = useFirebase()

  const handleClick = () => {
    if (logEventParameter) {
      analytics.logEvent('side_menu_click', { modulo_selecionado: logEventParameter })
      analytics.logEvent(logEventParameter)
    } else {
      analytics.logEvent('side_menu_click')
    }
    onNavigate && onNavigate()
  }

  const totalNotificacoes = useNotificacaoCount(notificacoes)

  const {
    configuracoes: { rocksdbEnabled },
  } = useConfiguracoes()

  if (!rocksdbEnabled && (to === RELATORIO_GERENCIAL_VACINACAO_PATH || to === RELATORIO_GERENCIAL_ATENDIMENTOS_PATH)) {
    return null
  }

  return (
    <li className={classes.subitem}>
      <NavLink className={classes.sublink} onClick={handleClick} to={to} {...rest}>
        <Text color='inherit'>
          <NormalizedHighlighter searchWords={highlight} textToHighlight={title} />
        </Text>
        <BadgeNotificacao type='large' value={totalNotificacoes}></BadgeNotificacao>
      </NavLink>
    </li>
  )
}

export const createStyles = (theme: Theme) => ({
  subitem: {
    background: theme.pallete.gray.c90,
  },
  sublink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.pallete.text.main,
    textDecoration: 'none',
    outline: 'none',
    padding: '0.5rem 1.5rem 0.5rem 5rem',
    fontWeight: 'normal',

    '&:hover': {
      background: hexToRGB(theme.pallete.gray.c20, 0.1),
    },

    '&:focus': {
      borderRadius: 4,
      boxShadow: focusBoxShadow(theme, 'primary', 'inset'),
    },

    '&.active': {
      color: theme.pallete.primary.main,
      fontWeight: 'bold',
    },
  } as CSSProperties,
})
